import { render, staticRenderFns } from "./likes.vue?vue&type=template&id=09e94ebf"
import script from "./likes.vue?vue&type=script&lang=ts"
export * from "./likes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports